import { Link } from "react-router-dom";
import type { NewsItem } from "@/mocks/news";

type NewsCardProps = {
  item: NewsItem;
  variant?: "grid" | "list";
};

export default function NewsCard({ item, variant = "grid" }: NewsCardProps) {
  if (variant === "list") {
    return (
      <Link
        to={`/news/detail/${item.id}`}
        className="group flex gap-3 md:gap-4 rounded-lg border border-background-200 bg-background-50 p-2.5 md:p-3 hover:border-primary-200 transition-colors cursor-pointer"
      >
        <div className="w-24 h-20 md:w-36 md:h-24 shrink-0 rounded-md overflow-hidden bg-background-200">
          <img
            src={item.cover}
            alt={`${item.title} - age动漫资讯配图`}
            title={`${item.title} - 动漫资讯`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.03]"
          />
        </div>
        <div className="min-w-0 flex-1 flex flex-col justify-center">
          <div className="flex items-center gap-2 text-[11px] text-foreground-400 mb-1">
            <span className="px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-900">{item.tag}</span>
            <span>{item.publishedAt}</span>
          </div>
          <h3 className="text-sm md:text-base font-semibold text-foreground-900 line-clamp-2 group-hover:text-primary-600 transition-colors leading-snug">
            {item.title}
          </h3>
          <p className="hidden md:block mt-1.5 text-xs text-foreground-500 line-clamp-2 leading-relaxed">{item.summary}</p>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/news/detail/${item.id}`}
      className="group flex flex-col rounded-lg border border-background-200 bg-background-50 overflow-hidden hover:border-primary-200 transition-colors cursor-pointer"
    >
      <div className="w-full aspect-[16/9] overflow-hidden bg-background-200">
        <img
          src={item.cover}
          alt={`${item.title} - age动漫资讯封面`}
          title={`${item.title} - 动漫资讯`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.03]"
        />
      </div>
      <div className="flex flex-col flex-1 p-4">
        <div className="flex items-center gap-2 text-[11px] text-foreground-400 mb-2">
          <span className="px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-900">{item.tag}</span>
          <span>{item.publishedAt}</span>
        </div>
        <h3 className="text-base font-semibold text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
          {item.title}
        </h3>
        <p className="mt-2 text-sm text-foreground-500 leading-relaxed line-clamp-2 flex-1">{item.summary}</p>
        <div className="mt-3 pt-3 border-t border-background-100 flex items-center justify-between text-[11px] text-foreground-400">
          <span>{item.author}</span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {item.views.toLocaleString("zh-CN")}
          </span>
        </div>
      </div>
    </Link>
  );
}